// src/theme/palettes/lightPalette.js
import { colors } from '../tokens/colors';

export const lightPalette = {
  mode: 'light',
  common: {
    white: colors.white,
    black: colors.black,
  },
  // Default primary/secondary colors (these will be overridden dynamically)
  primary: {
    main: '#4962e5',
    light: '#6b7fed',
    dark: '#3d52c4',
    contrastText: '#ffffff',
  },
  secondary: {
    main: '#7c3aed',
    contrastText: '#ffffff',
  },
  success: {
    main: '#90c300',
    contrastText: '#ffffff',
  },
  warning: {
    main: '#FF6900E5',
    contrastText: '#ffffff',
  },
  error: {
    main: '#FB2C36',
    contrastText: '#ffffff',
  },
  info: {
    main: '#2e90fa',
    contrastText: '#ffffff',
  },
  grey: colors.grey,
  background: {
    default: colors.grey[50], // Very light grey for app background
    paper: colors.white,      // White for cards and panels
  },
  text: {
    primary: colors.grey[900],
    secondary: colors.grey[700],
    disabled: colors.grey[500],
  },
  divider: colors.grey[300],
  action: {
    hover: colors.grey[100],
    selected: colors.grey[200],
    disabledBackground: colors.grey[200],
  },
};
